import ApiClient from './ApiClient'

const API_NAME = 'WeConnect'
const client = new ApiClient(API_NAME)

export default {
  get(businessId) {
    return client.get(`/business/${businessId}/simulation/history`)
  }
}